import SignOutButton from "../auth/SignOutButton";
import NoticeCard from "../components/ui/NoticeCard";

export default function NotAuthorizedPage() {
  return (
    <NoticeCard title="Not authorized" action={<SignOutButton />} className="max-w-xl">
      Your account isn&apos;t in the admin group. If you believe this is a mistake, contact
      the Jiva team.
    </NoticeCard>
  );
}
